const { createContext, useState } = require("react");

const ConectaZapContext = createContext();

const ConectaZapContextProvider = ({ children }) => {
  const [instancesConectaZap, setInstancesConectaZap] = useState([]);
  const [loadingPage, setLoadingPage] = useState(false);

  return (
    <ConectaZapContext.Provider
      value={{
        instancesConectaZap,
        setInstancesConectaZap,
        loadingPage,
        setLoadingPage,
      }}
    >
      {children}
    </ConectaZapContext.Provider>
  );
};

export { ConectaZapContextProvider, ConectaZapContext };
